import { Badge } from '@mantine/core'

const SEVERITY_COLORS: Record<string, string> = {
  critical: 'red',
  high: 'orange',
  medium: 'yellow',
  low: 'blue',
  info: 'gray',
}

interface SeverityBadgeProps {
  severity: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export function SeverityBadge({ severity, size = 'sm' }: SeverityBadgeProps) {
  const color = SEVERITY_COLORS[severity.toLowerCase()] ?? 'gray'
  return (
    <Badge color={color} variant="light" size={size} radius="sm">
      {severity.toUpperCase()}
    </Badge>
  )
}
